<template>
  <v-container class="transparent">
    <v-toolbar dark>
          <v-toolbar-title>Select Product</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text v-on:click="gotoNext()">
            Next
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
        <br>
   
      <v-row>
     <v-col>
     <v-card
        dark
        class="mx-auto"
        v-bind:disabled="selectedProduct=='wolfhound'"
            max-width="400"
            raised>
            <v-img
              class="white--text align-end"
              height="200px"
              :src="require('@/assets/beagle.jpg')" 
            ></v-img>
            <v-card-title>Beagle</v-card-title>
            <v-card-subtitle class="justify-center">$15 CAD / month</v-card-subtitle>
            <v-list three-line>
                <v-subheader>Designed for light faxing needs</v-subheader>

                <v-divider
                  
                ></v-divider>

                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>5 outgoing faxes per 24 hours</v-list-item-title>
                    <v-list-item-subtitle >Above five will be queued and held until the following period</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>1 line for incoming faxes</v-list-item-title>
                    <v-list-item-subtitle>Callers may receive busy signal if your line is currently receiving a fax.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>Fax to email</v-list-item-title>
                    <v-list-item-subtitle >Faxes will be delivered as a PDF to your email</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>Web portal</v-list-item-title>
                    <v-list-item-subtitle >View incoming and send faxes through our state of the art web portal.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-card-actions >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
          <br>
          <v-layout align-center justify-center>
          <v-btn color="success" class="text-xs-center" v-bind:disabled="selectedProduct=='beagle'"
            v-on:click="selectedProduct='beagle'"
          >Choose Beagle
          </v-btn>
          </v-layout>
         </v-col>
          <v-col>
          <v-card
            class="mx-auto"
            v-bind:disabled="selectedProduct=='beagle'"
            max-width="400"
            color="rgb(255, 255, 255)"
            raised>
            <v-img
              class="white--text align-end"
              height="200px"
              :src="require('@/assets/wolfhound2.jpg')" 
            ></v-img>
            <v-card-title>Wolfhound</v-card-title>
            <v-card-subtitle class="justify-center">$25 CAD / month</v-card-subtitle>
            <v-list three-line>
                <v-subheader>Designed for businesses that rely on faxing</v-subheader>

                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>All of the Beagle features</v-list-item-title>
                    <v-list-item-subtitle >Including fax to email, web portal, and multi-user.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>50 outgoing faxes per 24 hours</v-list-item-title>
                    <v-list-item-subtitle >Above fifty will be queued and held until the following period</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>5 lines for incoming faxes</v-list-item-title>
                    <v-list-item-subtitle>Avoid busy signals by accepting up to 5 faxes at the same time.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>PDF Drop</v-list-item-title>
                    <v-list-item-subtitle >Coming soon. Receive PDF files from people without a fax at https://faxhound.com/[your fax number]</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

            </v-list>
            <v-card-actions >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
          <br>
          <v-layout align-center justify-center>
          <v-btn color="success" v-bind:disabled="selectedProduct=='wolfhound'"
            v-on:click="selectedProduct='wolfhound'"
          >Choose Wolfhound</v-btn>
          </v-layout>
          </v-col>
      </v-row>
  </v-container>

  
</template>

<script>

  import SignupMixin from '../mixins/SignupMixin.vue';

  export default {
    name: 'SignupPackage',
    props: {
      
    },
    mixins: [SignupMixin],
    computed: {
      
    },
    data: () => ({
      packages: [
        {text: 'Wolfhound', value: 'wolfhound'},
        {text: 'Beagle', value: 'beagle'},
      ]
     
    }),
    methods: {
      gotoNext: function() {
        this.$emit('gotoNext');
      },
    },
    beforeMount() {
    },
    watch: {

    },
    filters: {

    },
  }
</script>
